import { BefRepository, BefRepositoryUtil, ResponseInfo } from '@farris/bef';
import { FrameContext } from '@farris/devkit';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export class DataChangeDetectionService {
  public static hasChange(frameContext: FrameContext): Observable<boolean> {
    const befRepository = frameContext && frameContext.repository as BefRepository<any>;
    const hasLocalChanges = BefRepositoryUtil.isExistUnsaveData(befRepository);
    if (hasLocalChanges) {
      return of(true);
    }
    // æ¬å°æ²¡æåæ´ï¼ç¡®è®¤æå¡å¨ç«¯æ¯å¦ææªä¿å­çåæ´
    const virtualRootFrameContext = frameContext && frameContext.getVirtualRootFrameContext();
    const serverSideChangeDetectionEnabled = virtualRootFrameContext && virtualRootFrameContext.enableServerSideChangeDetection;
    if (!serverSideChangeDetectionEnabled) {
      return of(false);
    } else {
      // å¯ç¨äºåç«¯åæ´æ£æµ
      return frameContext.repository.hasChanges().pipe(map((response: ResponseInfo) => {
        return response.returnValue;
      }));
    }
  }
}
